import { TechnologyUseSelectDto, UserProfileRole } from '@@types/api.types';
import { Tile } from '@components/shared/tile.component.tsx';
import { useGetTechnologyUsesWithAssessments } from '@queries/technology-uses.query.ts';
import { useGetTechnology } from '@queries/technology.query.ts';
import { useGetCurrentUser } from '@queries/users.query.ts';
import { isChildOrganizationView as getIsChildOrganizationView } from '@utils/parent-organization.util';
import { FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TechnologyUseContainer } from './technology-use-item.component.tsx';
import { TechnologyUseModal } from './technology-use-modal.component.tsx';

export const TechnologyUses: FunctionComponent = () => {
  const { technologyId } = useParams();
  const { data: technology, isPending: isTechnologyLoading } = useGetTechnology(technologyId);
  const { data: user, isSelectedCompanyParentOrganization, selectedCompany } = useGetCurrentUser();
  const isChildOrganizationView = getIsChildOrganizationView({
    isSelectedCompanyParentOrganization,
    selectedCompanyId: selectedCompany?.id,
    technologyCompanyId: technology?.company?.id,
  });
  const canEdit = user?.profile?.role === UserProfileRole.INNOVATOR && !isChildOrganizationView;

  const [addTechnologyUseModalOpen, setAddTechnologyUseModalOpen] = useState(false);
  const { data: technologyUses } = useGetTechnologyUsesWithAssessments(technology?.id);
  const [isEdit, setIsEdit] = useState(false);
  const [technologyUseToEdit, setTechnologyUseToEdit] = useState<TechnologyUseSelectDto | null>(null);

  const handleOpenModal = (use?: TechnologyUseSelectDto) => {
    setIsEdit(!!use);
    setTechnologyUseToEdit(use || null);
    setAddTechnologyUseModalOpen(true);
  };

  return (
    <Tile
      className="min-h-44"
      header={{
        button: canEdit ? { onClick: () => handleOpenModal(), text: '+ Add' } : undefined,
        title: 'Technology Uses',
      }}
      isLoading={isTechnologyLoading}
    >
      <div className="flex flex-col gap-4">
        {technology?.uses?.map((use, index) => (
          <TechnologyUseContainer
            key={use.id}
            isPrimary={index === 0}
            onEdit={canEdit ? () => handleOpenModal(use) : undefined}
            technologyUses={technologyUses}
            use={use}
          />
        ))}
      </div>
      {technology && canEdit && (
        <TechnologyUseModal
          isEdit={isEdit}
          isOpen={addTechnologyUseModalOpen}
          setIsOpen={setAddTechnologyUseModalOpen}
          technology={technology}
          use={technologyUseToEdit}
          totalUses={technology?.uses?.length || 0}
        />
      )}
    </Tile>
  );
};
